import React from 'react'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Input, Modal, Row } from 'antd'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import { toJsonText, parseJsonText, jsonObjectRule } from '../jsonField'

const HelperForm = (props) => {
  const { visible, onOk, onCancel, formData, partnerId, form } = props
  const { getFieldDecorator, validateFields } = form
  const isEdit = !_.isEmpty(formData)

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      form.setFieldsValue({
        apiName: formData.apiName,
        endpointApi: formData.endpointApi,
        staticParams: toJsonText(formData.staticParams)
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields((err, values) => {
      if (err) return
      onOk({
        partnerId: Number(partnerId),
        apiName: values.apiName.trim(),
        endpointApi: values.endpointApi.trim(),
        staticParams: parseJsonText(values.staticParams)
      })
    })
  }

  return (
    <Modal
      title={`${isEdit ? 'แก้ไข' : 'สร้าง'} Helper`}
      visible={visible}
      footer={null}
      onCancel={onCancel}
      width={560}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="API Name">
          {getFieldDecorator('apiName', {
            rules: [{ required: true, message: 'กรุณากรอก API Name' }]
          })(<Input />)}
        </Form.Item>

        <Form.Item label="Endpoint">
          {getFieldDecorator('endpointApi', {
            rules: [{ required: true, message: 'กรุณากรอก Endpoint' }]
          })(<Input placeholder="/api/lookup" />)}
        </Form.Item>

        <Form.Item label="Static Params (JSON)">
          {getFieldDecorator('staticParams', { rules: [jsonObjectRule] })(
            <Input.TextArea
              rows={4}
              style={{ fontFamily: 'monospace' }}
              placeholder='{"key": "value"}'
            />
          )}
        </Form.Item>

        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default Form.create({ name: 'HelperForm' })(HelperForm)
